module.exports = __webpack_public_path__ + "media/images/summit-6-5ee6ca6d135964883adef6cc00b4a049.jpg";